import { Button, Checkbox } from "@similarweb/ui-components";

import { translate } from "app/filters/i18nFilter";
import type { StructuredChartDataSchema } from "app/pages/benchmark-tracker/hooks/types";

import { Marker } from "../../../common/Marker";
import { TooltipValue } from "../styles";

import { ButtonContainer, LegendContainer, StyledWrapper } from "./styles";

type LegendSchema = {
    chartData: Array<StructuredChartDataSchema>;
    onClick: () => void;
    isDifferenceSelected: boolean;
    onOpenModal: () => void;
};

const Legend = ({ chartData, onClick, isDifferenceSelected, onOpenModal }: LegendSchema) => (
    <LegendContainer>
        {chartData?.map((item, i) => (
            <StyledWrapper key={i}>
                <Marker backgroundColor={item?.color} />
                <TooltipValue>{item?.name}</TooltipValue>
            </StyledWrapper>
        ))}
        <Checkbox
            onClick={onClick}
            selected={isDifferenceSelected}
            label={translate("bt.metrics.ranking.difference")}
        />

        <ButtonContainer>
            <Button
                type="flat"
                onClick={onOpenModal}
                dataAutomation="bt-ranking-widget-cta"
            >
                {translate("bt.report.metric.btn.view_more.text")}
            </Button>
        </ButtonContainer>
    </LegendContainer>
);

export default Legend;
